import { type FC, type PropsWithChildren } from "react";
import { useSelector } from "react-redux";

import { formatDateTimeFromISO } from "widgets";

import InformationPage from "./InformationPage.js";
import { type Configuration } from "@/graphql.ts";
import { type IAppState } from "@/redux/reducer.ts";

export const LicenseCheck: FC<PropsWithChildren> = ({ children }) => {
  const configuration = useSelector<IAppState, Configuration>((state) => state.config.configuration);

  const licenseError = configuration && (!configuration.license || !configuration.license.isValid);

  return licenseError ? (
    <InformationPage
      errorTitle={`${!configuration.license ? "Invalid License" : "License Expired"}`.toUpperCase()}
      noGoBackLink
    >
      {!configuration.license
        ? "No license has been configured for this system. Please contact your system administrator to register a license."
        : `Your license has expired${
            configuration.license.expirationDate
              ? " " + formatDateTimeFromISO(configuration.license.expirationDate, { hideTime: true })
              : ""
          }. Please contact your system administrator to renew the license.`}
    </InformationPage>
  ) : (
    children
  );
};
